import SectionButtonGroup from "../../../../../components/Button/SectionButtonGroup";
import InfoWatchlistText from "./InfoWatchlistText";
import InfoSeqText from "./InfoSeqText";



export default function DiseaseButtonGroup() {

return(
<>      

<SectionButtonGroup

      button_1 = "IMPORTANT READ"
      button_2 = "SEQUENCING INFO"
      button_3 = "COUNSELING"
      
      title_dialog_1 = "Individual Genetic Risks"
      content_dialog_1 = {<InfoWatchlistText />}
      
      title_dialog_2 = "Information - Sequencing Technology"
      content_dialog_2 = {<InfoSeqText />}

      to = "/Doctor"

/>

</>
)}